import { ComponentBase } from 'utils/abstract-classes/component-base'
import { ApiService } from 'services/api/api.service'

export class FeatureBarComponent extends ComponentBase {
    public constructor(private readonly element: HTMLElement) {
        super()
        let type = 'breakingnews'
        if (element.classList.contains('promotional')) {
            type = 'promotional'
        } else if (element.classList.contains('slogan')) {
            type = 'slogan'
        }
        const apiSetvice = new ApiService()
        apiSetvice
            .getFeatureBar(type)
            .then((featureBar: string | void) => {
                if (featureBar) {
                    const featureBarParent = document.createElement('div')
                    featureBarParent.innerHTML = featureBar
                    const featureBarDiv = featureBarParent.firstElementChild
                    if (featureBarDiv) {
                        featureBarDiv.removeAttribute('data-feature-bar')
                        this.element.replaceWith(featureBarDiv)
                    }
                }
            })
            .catch((e) => logger('error', e))
    }
}
